export default function parseButtonLink(input) {
    const btnPattern = /^btn(?:\[type="([^"]+)"\])?:([^\s]+)$/;
    const match = input.match(btnPattern);

    if (match) {
        const type = getButtonType(match[1]);
        const url = match[2];
        return {
            isButton: true,
            type,
            url,
        };
    } else {
        return {
            isButton: false,
            url: input,
        };
    }
}

const getButtonType = (type) => {
    switch (type) {
        case "primary":
            return 'Primary Button';
        case "primary-no-arrow":
            return 'Primary Button Without Arrow';
        case "secondary":
            return 'Secondary Button';
        case "secondary-no-arrow":
            return 'Secondary Button Without Arrow';
        case "simple":
            return 'Simple Button';
        case "contained":
            return 'Contained Button Link';
        case "contained-outer":
            return 'Contained Button Outer Link';
        case "submit":
            return 'Submit Button';
        case "submit-arrow":
            return 'Submit Arrow Button';
        case "outlined":
            return 'Outlined Button';
        case "destructive":
            return 'Destructive Button';
        default:
            return 'Primary Button';
    }
}